"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serializeForHtml = void 0;
/**
 * Safely serializes an object for embedding in HTML script tags.
 * Escapes characters that could break out of script context or cause XSS.
 */
const serializeForHtml = obj => JSON.stringify(obj).replace(/</g, "\\u003c").replace(/>/g, "\\u003e").replace(/&/g, "\\u0026").replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
exports.serializeForHtml = serializeForHtml;